import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useCreateColor } from '../../../hooks/COLORS/useCreateColor';

const NewColor = ({ showNewColor, setShowNewColor }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', hex: '#000000' });

    const { mutateAsync: createColor } = useCreateColor();

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) return;
        setIsSubmitting(true);
        try {
            await createColor({ name: formData.name, hex: formData.hex });
            setFormData({ name: '', hex: '#000000' });
            setShowNewColor(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setFormData({ name: '', hex: '#000000' });
        setShowNewColor(false);
    };

    return (
        <Modal show={showNewColor} onHide={handleClose} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Ajouter une couleur</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idName">
                        <Form.Label className='text-muted'>Nom <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" placeholder="Nom de la couleur" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required maxLength={100} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idHex">
                        <Form.Label className='text-muted'>Code hexadécimal <span className="text-danger">*</span></Form.Label>
                        <div className="d-flex align-items-center gap-3">
                            <Form.Control type="color" value={formData.hex} onChange={(e) => setFormData({ ...formData, hex: e.target.value })} style={{ width: '60px', height: '40px' }} />
                            <Form.Control type="text" placeholder="#000000" value={formData.hex} onChange={(e) => setFormData({ ...formData, hex: e.target.value })} pattern="^#[0-9A-Fa-f]{6}$" maxLength={7} />
                        </div>
                        <Form.Text className="text-muted">Format: #RRGGBB (ex: #FF0000 pour rouge)</Form.Text>
                    </Form.Group>
                    <div className="mb-3">
                        <Form.Label className='text-muted'>Aperçu</Form.Label>
                        <div className="d-flex align-items-center gap-3">
                            <div style={{ width: '100px', height: '100px', borderRadius: '8px', backgroundColor: formData.hex, border: '2px solid #dee2e6', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }} />
                            <div>
                                <p className="mb-1"><strong>{formData.name || 'Nom de la couleur'}</strong></p>
                                <p className="mb-0 text-muted">{formData.hex}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !formData.name.trim()}>
                        {isSubmitting ? 'Chargement...' : 'Créer'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default NewColor;